import React from "react";

import style from "./messageOverlay.module.scss";
import { StopSign } from "../StopSign/StopSign";

export const MessageOverlay = ({ title = "", message = "", withStopSight = false }) => (<div className={style["wrapper"]}>
  <div className={style["card"]}>
    <h1> {title} </h1>
    {withStopSight ? (<StopSign />) : null}
    <p> {message} </p>
  </div>
</div>);
